function B2C_LINK() {
    if (window.location.hostname.includes("localhost")) {
        console.log("have localhost: ", window.location.hostname);
        return 'http://localhost:3000/';
    } else {
        if (window.location.hostname.includes("mioga-int.gazella.solutions")) {
            return 'https://oga-b2c-int.gazella.solutions/';
        } else {
            if (window.location.hostname.includes("mioga-integration.oga.com.bo")) {
                return 'https://b2c-integration.oga.com.bo/';
            } else {
                if (window.location.hostname.includes("mioga.oga.com.bo")) {
                    return 'https://b2c.oga.com.bo/';
                }
                return "";
            }
        }
    }
}
export default B2C_LINK();



// WEBPACK FOOTER //
// ./src/utils/HttpClient/b2cLink.js